import { useMutation } from '@tanstack/react-query'
import { authApiClient } from '~/lib/api-client'

interface CheckoutArgs {
  productId: string
  returnUrl: string
}

export function useCheckout() {
  return useMutation({
    mutationFn: async ({ productId, returnUrl }: CheckoutArgs) => {
      const res = await authApiClient.payments.checkout.$post({
        json: { productId, returnUrl },
      })
      if (!res.ok) {
        const error = await res.json()
        throw new Error((error as any).message || 'Failed to create checkout session')
      }
      return res.json()
    },
    onSuccess: (data) => {
      if (data.url) {
        window.location.href = data.url
      }
    },
  })
}
